import { render, staticRenderFns } from "./signRules.vue?vue&type=template&id=2cad4074&scoped=true&"
import script from "./signRules.vue?vue&type=script&lang=js&"
export * from "./signRules.vue?vue&type=script&lang=js&"
import style0 from "./signRules.vue?vue&type=style&index=0&id=2cad4074&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad4074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cad4074')) {
      api.createRecord('2cad4074', component.options)
    } else {
      api.reload('2cad4074', component.options)
    }
    module.hot.accept("./signRules.vue?vue&type=template&id=2cad4074&scoped=true&", function () {
      api.rerender('2cad4074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/signRules.vue"
export default component.exports